import { useEffect, useState } from 'react';

import { getCookie } from '@zooplus/commons-lang';

import { MOBILE_APP_COOKIE } from '@utilities/constants';

export const useMobileApp = () => {
  const [isMobileApp, setIsMobileApp] = useState(false);

  useEffect(() => {
    setIsMobileApp(Boolean(getCookie(MOBILE_APP_COOKIE)));
  }, []);

  return isMobileApp;
};
